import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { firebase } from './firebase';

// Providers
import { StyledEngineProvider } from '@mui/material/styles';
import { GameContextProvider } from './contexts/GameContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<StyledEngineProvider injectFirst>
			<GameContextProvider>
				<App />
			</GameContextProvider>
		</StyledEngineProvider>
	</React.StrictMode>
);

// Initialize Firebase
firebase.init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
